import SurveyCard from "./SurveyCard";
import { useQuery } from "@tanstack/react-query";
import { getSurveysOptions } from "@pulse/api/queryApi";
import { useMemo } from "react";

export default function RecentSurveys({ pulseInstanceId }: { pulseInstanceId: number }) {
    const { data } = useQuery(getSurveysOptions({ pulseInstanceId }));

    const sortedData = useMemo(() => {
        return data?.slice().sort((a, b) => {
            const dateA = new Date(a.createdAt).getTime();
            const dateB = new Date(b.createdAt).getTime();
            return dateB - dateA; // Sort by createdAt in descending order
        });
    }, [data]);

    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8 items-stretch">
            {sortedData?.map((survey) => <SurveyCard key={survey.id} {...survey} />).splice(0, 8)}
        </div>
    );
}
